module.exports = __webpack_public_path__ + "0c457b8de4bd05d2a116b58a10344f.png";